import axios from 'axios';
window.axios = axios;

import './services/functions';
import './services/extended_search_print_edition';
import './services/extended_search_web';
import './services/main_search';
import './services/share_button';
import './services/markup_scripts';
import './services/pdf_viewer';